// Bridges the gap between a successful Stripe purchase on the client and the
// backend's `isPremium` flag being flipped by the Stripe webhook. Without this,
// a refresh during that window flips the user back to free until the webhook
// lands (usually within seconds, sometimes more).

const COOKIE_NAME = "premium_grace_period";
const TEN_MINUTES_SECONDS = 600;

export const setPremiumGracePeriod = () => {
  document.cookie = `${COOKIE_NAME}=1; max-age=${TEN_MINUTES_SECONDS}; path=/; SameSite=Lax`;
};

export const clearPremiumGracePeriod = () => {
  document.cookie = `${COOKIE_NAME}=; max-age=0; path=/; SameSite=Lax`;
};

export const hasPremiumGracePeriod = () =>
  document.cookie.split("; ").some((c) => c.startsWith(`${COOKIE_NAME}=1`));
